export default __webpack_public_path__ + "static/media/caps8.114f5471.gif";